import { BULK_ASSET_JOB_CREATION_KEY } from '~/constants/bulkAssetOperations';

export type BulkAssetJobCreation = {
  assetIds: string[];
  jobType?: 'service' | 'clean' | 'job';
  templateId?: string;
  assets: Array<{
    id: string;
    name: string;
    type?: string;
    deploymentLocationId?: string;
    deploymentLocationName?: string;
    deploymentSpaceName?: string;
  }>;
};

export function parseBulkAssetJobCreation(
  stored: string | null
): BulkAssetJobCreation | null {
  if (!stored) return null;

  try {
    return JSON.parse(stored) as BulkAssetJobCreation;
  } catch (e) {
    console.error('Failed to parse bulk asset data:', e);
    return null;
  }
}

export function readBulkAssetJobCreation(
  storage: Pick<Storage, 'getItem'> = sessionStorage
): BulkAssetJobCreation | null {
  try {
    return parseBulkAssetJobCreation(
      storage.getItem(BULK_ASSET_JOB_CREATION_KEY)
    );
  } catch (e) {
    console.error('Failed to parse bulk asset data:', e);
    return null;
  }
}

/**
 * Location for a bulk-asset job. Callers validate a single site before write;
 * if multiple IDs slip through, the first non-empty deployment location wins.
 */
export function getBulkAssetLocationId(
  assets: BulkAssetJobCreation['assets'] | undefined
): string | undefined {
  if (!assets?.length) return undefined;
  const locationIds = assets
    .map((a) => a.deploymentLocationId)
    .filter((id): id is string => !!id);
  return locationIds[0];
}
